var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcCompletion = function SvgIcCompletion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ic_completion_svg__st0",
    d: "M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0zm6.03 9.89-6.35 6.35a1.499 1.499 0 0 1-2.12 0l-3.59-3.59a1.49 1.49 0 0 1 0-2.12 1.49 1.49 0 0 1 2.12 0l2.53 2.53 5.29-5.29a1.49 1.49 0 0 1 2.12 0c.59.59.59 1.54 0 2.12z"
  })));
};
export default SvgIcCompletion;